type Props = {
  text?: string
}

const PendingLoader: React.FC<Props> = ({ text }) => {
  return (
    <div>
      <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 flex items-center justify-center z-50">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
      </div>
      <p className="absolute top-32 left-0 w-full h-full flex items-center justify-center z-50">
        {text}
      </p>
    </div>
  )
}

export default PendingLoader
